import { render, staticRenderFns } from "./SelectedCustomerInfo.vue?vue&type=template&id=5d91925c&"
import script from "./SelectedCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./SelectedCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports